import React from "react";

const estiloLoading = require("./Loading.module.scss").default;

export type LoadingProps = {
  carregandoConteudo?: boolean;
};

const Loading = ({ carregandoConteudo }: LoadingProps) => {
  return (
    <>
      {carregandoConteudo && (
        <div className={estiloLoading.overlay}>
          <div className={estiloLoading.circle1} />
        </div>
      )}
    </>
  );
};

export { Loading };
